import { createContext, useContext, useReducer } from "react";
import PropTypes from "prop-types";

const WithdrawalFormDetailsContext = createContext();
WithdrawalFormDetailsContext.displayName = "withdrawalForm";

export const useWithdrawalFormDetails = () =>
  useContext(WithdrawalFormDetailsContext);

export const WithdrawalFormDetailsProvider = ({
  children,
  initialState,
  reducer,
}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <WithdrawalFormDetailsContext.Provider value={[state, dispatch]}>
      {children}
    </WithdrawalFormDetailsContext.Provider>
  );
};

WithdrawalFormDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    withdrawalFormDetails: PropTypes.object.isRequired,
  }),
  reducer: PropTypes.func.isRequired,
};
